import loggingDevInfo from '@/services/log-dev-info';
import apiRequest, {http_headers_azure} from '@/services/api-request.js';
import setupAppInsights from '@/plugins/setup-app-insights.js';
import {doesBrowserSupportLocalStorage} from '../utils/localStorage';
import {getCookieValue} from '@/util/cookies.js';
import TourService from '@/services/tour/Service.js';

export default (router) => ({
	state: {
		LANG: null,
		Language: null,
		COUNTRY: null,
		categories: [],
		categoryDependencies: [],
		selectedCategories: {
			application: null,
			startingMaterial: null,
			analyte: null,
			technology: null,
		},
		productsList: null,
		showProductsFilter: false,
		cvlWebSteps: null,
		cartId: '',
		applicationProducts: {},
		startingMaterialProducts: {},
		analyteProducts: {},
		analysisTypeProducts: {},
		localProdSteps: {},
		jwt: null,
		qiagenPublicKeys: null,
		workflowHeadline: null,
		workflowDefaultHeadline: null,
		workflowID: null,
		isSharedWorkflow:false,
		isSavedWorkflow:false,
		supportsLocalStorage: null,
		myWorkflows: null,
		myWorkflow: null,
		geneGlobeLink: '',
		fallbackImageLink: '',
		cartEndpoint: '',
		demoRequestLink: '',
		inquireInstrumentLink: '',
		inquireStandardLink: '',
		customerPricesEndpoint: '',
		salesProspectEndpoint: '',
		enableShareUrl: null,
		dataUrlPrefix: '',
		loginLink: '',
		registrationLink: '',
		workflowsEndpoint: '',
		hcube: {
			stepsList: null,
			entryPointsList: null,
			config: null,
			productPriorities: null,
			workflows: null,
		},
		lastModDate: null,
		noWorkflowFound: false,
		salesGenomicSnackbarActive: false,
		mobileView: 600,
		qspData: null,
		qspProductsData: null,
		quickStartProtocols: null,
		stepProductFilters: {},
		workflowNamesDict: {},
		pclLabels: new Map(),
		productFinderEnabled: false,
		productFinderUrl: '',
	},
	getters: {
		getLoggedInStatus(state) {
			const jwt = state.jwt;
			return jwt ? `${jwt.lastName}, ${jwt.firstName}` : null;
		},
		getQuickStartProtocol: (state) => (productId) => {
			if (state.quickStartProtocols.hasOwnProperty(productId)) {
				return state.quickStartProtocols[productId];
			} else {
				return [];
			}
		},
		getStepNames: (state) => (steps) => {
			let stepNames = [];
			steps.forEach((step) => {
				const stepKey = state.hcube.stepsList[0][step.i];
				const foundStep = state.cvlWebSteps.values.find((el) => el.key === stepKey);
				stepNames.push({index: foundStep.index, name: foundStep.value['enUS']});
			});
			return stepNames;
		},
		entryPoints: (state) => state.hcube.entryPointsList,
		getPclLabel: (state) => (key) => state.pclLabels.get(key),
	},
	mutations: {
		setSalesGenomicSnackbarActive(state, payload) {
			state.salesGenomicSnackbarActive = payload;
		},
		setNoWorkflowFound(state, payload) {
			state.noWorkflowFound = payload;
		},
		setCategories(state, payload) {
			state.categories = payload.categories;
		},
		setWorkflowNamesDict(state) {
			let dict = {};
			let addWorkflowName = (el) => {
				dict[el.key] = el?.value?.enUS || el.key;
				el.children?.forEach((el) => addWorkflowName(el));
			};
			state.categories.forEach((category) => {
				category.options.forEach((el) => addWorkflowName(el));
			});

			state.workflowNamesDict = dict;
		},
		setCategorySelection(state, payload) {
			const category = payload.category;
			const selection = payload.selection;
			state.selectedCategories[category] = selection;
		},
		setHelperFiles(state, payload) {
			payload.forEach(({name, data}) => {
				state[name] = data;
			});
		},
		setLanguage(state, {country, language}) {
			/** TBD: state global lang based on selected country and lang that are offered
			 * const languagesOffered = ['enUS', 'zhCN', 'koKR', 'jaJP'];
			 * const lang = languagesOffered.filter((l) => l.endsWith(country));
			 * state.LANG = !lang.length ? 'enUS' : lang[0];
			 */

			state.Language = language;
			state.COUNTRY = country;
			state.LANG = 'enUS';
		},
		setCartId(state, payload) {
			state.cartId = payload;
		},
		setJWT(state, payload) {
			if (payload === null) return (state.jwt = payload);
			const jwtObj = (token) => {
				const base64Url = token.split('.')[1];
				const base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
				const jsonPayload = decodeURIComponent(
					atob(base64)
						.split('')
						.map((c) => '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2))
						.join(''),
				);
				return JSON.parse(jsonPayload);
			};
			state.jwt = jwtObj(payload);
		},
		setQiagenPublicKeys(state, payload) {
			state.qiagenPublicKeys = payload;
		},
		setWorkflowHeadline(state, payload) {
			state.workflowHeadline = payload;
		},
		setWorkflowDefaultHeadline(state, payload) {
			state.workflowDefaultHeadline = payload;
		},
		setWorkFlowId(state, payload) {
			state.workflowID = payload;
		},
		setSupportsLocalStorage(state, payload) {
			state.supportsLocalStorage = payload;
		},
		setLastModDate(state, payload) {
			state.lastModDate = payload;
		},
		setMyWorkflows(state, payload) {
			state.myWorkflows = payload;
		},
		setAppendMyWorkflows(state, payload) {
			state.myWorkflows = [...state.myWorkflows, ...payload];
		},
		setMyWorkflow(state, payload) {
			state.myWorkflow = payload;
		},
		setConfigs(state, payload) {
			const {name, url} = payload;
			state[name] = url;
		},
		renameWorkflowName(state, {newName, workflow}) {
			if (!state.myWorkflows) return;
			const wf = state.myWorkflows.find((w) => w.id === workflow.id);
			wf.title = newName;
		},
		addWorkflow(state, workflow) {
			if (!state.myWorkflows) return;
			state.myWorkflows.unshift(workflow);
		},
		setEnableShareUrl(state, payload) {
			state.enableShareUrl = payload;
		},
		setQuickStartProtocols(state, payload) {
			state.quickStartProtocols = payload;
		},
		setStepProductFilters(state, {step, filters}) {
			state.stepProductFilters[step] = filters;
		},
		clearStepProductFilters(state) {
			state.stepProductFilters = {};
		},
		setPclLabels: (state, payload) =>
			payload.forEach(({key, value}) => state.pclLabels.set(key, value[state.Language] || value['enUS'])),
	},
	actions: {
		checkPublicationIds({commit, state}) {
			const wfcdataPublicationId = state.hcube.publication_id;
			if (wfcdataPublicationId === '') {
				let error = new Error('wfcdata has empty publiccation_id.');
				window.appInsights.trackException({exception: error});
			}
			if (wfcdataPublicationId !== state.cvlWebSteps.publication_id) {
				let error = new Error('CVLSteps has wrong publiccation_id.');
				window.appInsights.trackException({exception: error});
			}
			state.categories.forEach((cat) => {
				if (wfcdataPublicationId !== cat.publication_id) {
					let error = new Error(`${cat.category} has wrong publiccation_id.`);
					window.appInsights.trackException({exception: error});
				}
			});
		},
		fetchHelperFiles({commit, state, dispatch}) {
			const mspQSPProducts = (productQSPs, protocols) =>
				Object.entries(productQSPs).reduce((acc, [productId, protocolIds]) => {
					acc[productId] = protocolIds.map((protocolId) => ({protocolId, ...protocols[protocolId]}));
					return acc;
				}, {});

			if (state.productsList || state.cvlWebSteps || state.cvlFilter || state.jobPositions || state.states)
				return;
			const curlPrefix = state.dataUrlPrefix;
			const files = [
				{key: 'hcube', name: 'wfcdata'},
				{key: 'productsList', name: 'Products'},
				{key: 'cvlWebSteps', name: 'CVL_WBSteps'},
				{key: 'cvlFilter', name: 'CVL_WBFilterCategories'},
				{key: 'pclevelLables', name: 'CVL_PCLevelLabel'},
				{key: 'pclevelProducts', name: 'CVL_PCLevelLabelProduct'},
				{key: 'pclevelSizes', name: 'CVL_PCLevelLabelSize'},
				{key: 'jobPositions', name: 'job_positions'},
				{key: 'states', name: 'states'},
				{key: 'qspData', name: 'qsp'},
				{key: 'qspProductsData', name: 'qsp_products'},
			];
			return Promise.all(
				files.map(async (file) => {
					const data = await apiRequest(`${curlPrefix}${file.name}.json`, 'get', null, http_headers_azure, {
						withCredentials: false,
					});
					return {name: file.key, data};
				}),
			)
				.then((obj) =>
					obj.filter(({name, data}) =>
						!name.startsWith('pclevel') ? {name, data} : (commit('setPclLabels', data.values), false),
					),
				)
				.then((obj) => commit('setHelperFiles', obj))
				.then(() => commit('setQuickStartProtocols', mspQSPProducts(state.qspProductsData, state.qspData)))
				.catch((e) => loggingDevInfo(e, 'error'));
		},
		fetchCategories({commit, state}) {
			// later, this is where categories will be fetched asynchronously.
			// currently, we simply call commit with the mock data we have.

			const curlPrefix = state.dataUrlPrefix;
			if (state.categories.length > 0) return state.categories;

			const files = [
				{key: 'Application', name: 'CVL_WBApplication'},
				{key: 'Starting material', name: 'CVL_WBStartingMaterial'},
				{key: 'Analyte', name: 'CVL_WBAnalyte'},
				{key: 'Analysis type', name: 'CVL_WBAnalysisType'},
			];
			return Promise.all(
				files.map(async (file) => {
					const data = await apiRequest(`${curlPrefix}${file.name}.json`, 'get', null, http_headers_azure, {
						withCredentials: false,
					});
					return {category: file.key, options: data?.values, publication_id: data?.publication_id};
				}),
			)
				.then((obj) => {
					commit('setCategories', {categories: obj});
					commit('setWorkflowNamesDict');
				})
				.catch((e) => loggingDevInfo(e, 'error'));
		},
		async fetchUrls({commit, state}) {
			if (state.workflowsEndpoint) return;
			try {
				const {product, wfc, geneglobe, global, appInsightsKey, registration} = await apiRequest(
					'/workflow-configurator/configuration',
				);

				const configs = {
					demoRequestLink: product['demo-request-link'],
					inquireInstrumentLink: product.inquire['instrument-link'],
					inquireStandardLink: product.inquire['standard-link'],
					customerPricesEndpoint: wfc.endpoint['customer-prices'],
					dataUrlPrefix: wfc.endpoint.dataUrlPrefix,
					loginLink: wfc.endpoint.login,
					workflowsEndpoint: wfc.endpoint.workflows,
					salesProspectEndpoint: wfc.endpoint.salesProspect,
					enableShareUrl: wfc['share-url'],
					showProductsFilter: wfc['show-products-filter'],
					geneGlobeLink: geneglobe?.['product-group']['page-url'],
					fallbackImageLink: product['fallback-image'],
					sharedEndpoint: '/workflow-configurator/api/shared_workflows',
					registrationLink: `${registration.url}?returnUrl=_CURRENT_URL_`,
					publicationEndpoint: wfc.endpoint.publication || '/workflow-configurator/api/publication',
					productFinderEnabled: wfc.features.productFinder,
					productFinderUrl: wfc.endpoint.productFinder,
				};
				if (appInsightsKey) {
					setupAppInsights(appInsightsKey, router);
				}
				Object.entries(configs).forEach((entry) => commit('setConfigs', {name: entry[0], url: entry[1]}));
			} catch (e) {
				loggingDevInfo(e, 'error');
			}
		},
		buildWorkflowDefaultHeadline({commit, state}) {
			const lang = state.LANG;
			const {analyte, application, startingMaterial, technology} = state.selectedCategories;

			const ap = application.value[lang] || application.value.enUS;
			const sm = startingMaterial.value[lang] || startingMaterial.value.enUS;
			const an = analyte.value[lang] || analyte.value.enUS;
			const te = technology.value[lang] || technology.value.enUS;
			commit('setWorkflowDefaultHeadline', `${ap} - ${sm} - ${an} - ${te}`);
		},
		handleStartUpCookie({commit, state}) {
			let country = getCookieValue('COUNTRY');
			let language = getCookieValue('Language') || 'en';
			const jwt = getCookieValue('jwt');

			if (doesBrowserSupportLocalStorage('localStorage')) commit('setSupportsLocalStorage', true);

			// check and set tour status
			TourService.getTourStatus();

			// add jwt to store
			if (jwt) {
				commit('setJWT', jwt);

				country = state.jwt.country;
				document.cookie = `COUNTRY=${country}; domain=.qiagen.com; expires=${new Date(
					2147483647 * 1000,
				).toUTCString()}; path=/; secure`;
			}

			// if not, default to US.
			if (!country) country = 'US';

			commit('setLanguage', {country, language});
			commit('setCartId', getCookieValue('qiagen-cart'));
		},
	},
});
